module.exports = __webpack_public_path__ + "assets/fa-brands-400.a06da7f0950f9dd366fc9db9d56d618a.woff2";